import {useQuery, UseQueryOptions} from "react-query";
import Alert from "react-s-alert";
import {
  HubAndSpokeService,
  PDFTemplate,
} from "../../../services/HubAndSpokeService";

export const usePdfTemplatesQuery = ({
  templateName,
  workflowType,
  options,
}: {
  eventTriggerId?: string;
  templateName?: string;
  workflowType?: string;
  options?: UseQueryOptions<Array<PDFTemplate> | undefined>[];
}) =>
  useQuery(
    ["GET_PDF_TEMPLATES", templateName, workflowType],
    async () => {
      const {data} = await HubAndSpokeService.getPdfTemplates(
        templateName,
        workflowType,
      );
      return data;
    },
    {
      onError: () => {
        Alert.error("Failed to get PDF templates.");
      },
      cacheTime: 0,
      ...options,
    },
  );
